import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  minHeight: '20px',
  [`&`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.grey[150],
  },
}));

interface ProgressBarProps {
  completedNumber: number;
  totalNumber: number;
  zIndex?: number;
}

export default function ProgressBar(props: ProgressBarProps) {
  return (
    <Box display="flex" alignItems="center" pt={1} pb={2} style={{ padding: 0, flex: 1, zIndex: props.zIndex }}>
      <Box mr={1} style={{ padding: 0, minWidth: '100%' }}>
        <BorderLinearProgress
          variant="determinate"
          color="secondary"
          value={props.totalNumber ? Math.round((props.completedNumber / props.totalNumber) * 100) : 0}
          style={{ opacity: 100 }}
        />
      </Box>
      <Typography variant="body2" style={{ position: 'absolute', right: 10, color: 'white' }}>
        {`${props.completedNumber}/${props.totalNumber}`}
      </Typography>
    </Box>
  );
}
